module.exports = __webpack_public_path__ + "static/media/radiobutton_ON.5281309f.svg";